var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"unsubscribe"},[(_vm.isLoading)?_c('app-loading'):_c('div',[_c('p',{staticClass:"unsubscribe-message"},[_vm._v("\n      メール配信を"),_c('br',{staticClass:"sp-on"}),_vm._v("停止しました。\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-108c4af1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Unsubscribe.vue
// module id = 425
// module chunks = 0